import { validateGreaterThan } from './validateGreaterThan';
import { PASSWORD_ERROR_MESSAGE } from '~shared/constants';
const hasUppercase = (value: string) => /[A-Z]/.test(value);
const hasLowercase = (value: string) => /[a-z]/.test(value);
const hasNumber = (value: string) => /\d/.test(value);
const hasSpecialChar = (value: string) => /[^A-Za-z0-9]/.test(value);

export const validatePassword = (value: string): string | undefined => {
  if (!value) return undefined;

  const validators = [
    (v: string) => validateGreaterThan(11)(v) === undefined,
    hasUppercase,
    hasLowercase,
    hasNumber,
    hasSpecialChar,
  ];

  const isValid = validators.every((validator) => validator(value));

  return isValid ? undefined : PASSWORD_ERROR_MESSAGE;
};
